class ElementLocators {
  static LOCATOR_LOGIN_BUTTON = 'login-button-tid';
  static LOCATOR_LOGIN_USERNAME = 'login-username-tid';
  static LOCATOR_LOGIN_PASSWORD = 'login-password-tid';
  static LOCATOR_DETAILS_HEADER_SECTION = 'detailsHeader_section';
  static LOCATOR_NOTES_SECTION = 'notes_section';
  static LOCATOR_PIA_INFO_SECTION = 'pia_info_section';
  static LOCATOR_MIB_SECTION = 'mib_report_section';
  static LOCATOR_TRL_SECTION = 'trl_section';
  static LOCATOR_MVR_SECTION = 'mvr_section';
  static LOCATOR_RX_HISTORY_SECTION = 'rx_history_section';
  static LOCATOR_DISCLOSURE_SECTION = 'disclosure_section';
  static LOCATOR_MIB_ADD_MORE = 'mib-add-more';
  static LOCATOR_REASON_CHOICE_PANEL = 'reason-choice-panel';
  static LOCATOR_REASSIGN_UNDERWRITER_SECTION = 'reassign_underwriter_section';
  static LOCATOR_APS_SECTION = 'aps_section';
  static LOCATOR_EHR_SECTION = 'ehr_section';
  static LOCATOR_REINSTATEMENT_SECTION = 'reinstatement_section';
  static LOCATOR_LAB_PIQTURE_SECTION = 'lab_piqture_section';
  static LOCATOR_MEDICAL_CLAIMS_SECTION = 'medical_claims_section';
  static LOCATOR_SCRIPT_CHECK_SECTION = 'script_check_section';
  static LOCATOR_MIB_CODE_DETAILS_SECTION = 'script_mib_code_details_section';
  static LOCATOR_INSURANCE_LABS_SECTION = 'script_insurance_labs_section';
  static LOCATOR_CRIMINAL_RECORDS_SECTION = 'script_criminal_records_section';
  static LOCATOR_ETI_SECTION = 'eti_section';
  static LOCATOR_RULE_REVIEW_SECTION = 'rule_review_section';
  static LOCATOR_MIB_CODEBACK_DETAIL_SECTION = 'mibCodeback_section';
  static LOCATOR_ORDER_MIB_CODEBACK_SECTION = 'order_mibCodeback_section';
  static LOCATOR_MIB_CODE_INPUT_ACTIVE = 'mib-code-input-active';
  static LOCATOR_OTAF_REASONS_INPUT = 'otaf-reason';
  static LOCATOR_OTAF_REASONS_TEXT_AREA = 'otaf-reason-textarea';
  static LOCATOR_DOCTORS_INFO_INPUT = 'doctors-info';
  static LOCATOR_DOCTORS_INFO_TEXT_AREA = 'doctors-info-textarea';
  static LOCATOR_REVIEW_APPROVAL_BUTTON = 'approve-drawer-review-button';
  static LOCATOR_REVIEW_DECLINE_BUTTON = 'decline-drawer-review-button';
  static LOCATOR_REVIEW_POSTPONE_BUTTON = 'postpone-drawer-review-button';
  static LOCATOR_REVIEW_INELIGIBLE_BUTTON = 'ineligible-drawer-review-button';
  static LOCATOR_REVIEW_WAIVE_BUTTON = 'waive-drawer-review-button';
  static LOCATOR_SUBMIT_APPROVAL_BUTTON = 'approve-drawer-submit-button';
  static LOCATOR_SUBMIT_DECLINE_BUTTON = 'decline-drawer-submit-button';
  static LOCATOR_SUBMIT_POSTPONE_BUTTON = 'postpone-drawer-submit-button';
  static LOCATOR_SUBMIT_INELIGIBLE_BUTTON = 'ineligible-drawer-submit-button';
  static LOCATOR_SHOW_PII_DATA_BUTTON = 'show-pii-data-button';
  static LOCATOR_SHOW_OWNER_PII_DATA_BUTTON = 'show-owner-pii-data-button';
  static LOCATOR_AMENDMENT_TEXT_AREA = 'amendment-textarea';
  static DECLINE_DECISION_LINK = 'decline-decision-icon-link';
  static POSTPONE_DECISION_LINK = 'postpone-decision-icon-link';
  static APPROVE_DECISION_LINK = 'approve-decision-icon-link';
  static WITHDRAW_DECISION_LINK = 'withdraw-decision-icon-link';
  static LOCATOR_ADDITIONAL_INFORMATION_TASK = 'additional_informtion_task';
  static LOCATOR_SPECIAL_AUTHORIZATION = 'special_authorization_task';
  static LOCATOR_PLAN_F_TASK = 'plan_f_task';
  static LOCATOR_CARRIER_ELIGIBILITY_TASK = 'carrier_eligibility_task';
  static LOCATOR_AUTO_MEDICAL_CLAIMS_SECTION =
    'automatic_medical_claims_section';
  static LOCATOR_DASHBOARD_USER_FILTER_SECTION =
    'dashboard_user_filter_section';
  static LOCATOR_DASHBOARD_DISAGREE_TO_RESCIND_DESCRIPTION =
    'disagree_to_rescind_description';
  static LOCATOR_DASHBOARD_DISAGREE_TO_RESCIND_TEXTAREA =
    'disagree_to_rescind_textarea';
  static LOCATOR_DASHBOARD_REINSTATEMENT_DECISION_DESCRIPTION =
    'reinstatement_decision_description';
  static LOCATOR_DASHBOARD_REINSTATEMENT_DECISION_TEXTAREA =
    'reinstatement_decision_textarea';
  static LOCATOR_APS_SUMMARY_SECTION = 'aps_summary_section';
  static LOCATOR_EHR_SUMMARY_SECTION = 'ehr_summary_section';
  static LOCATOR_ADDITION_DATA_SECTION = 'additional_data_section';
  static LOCATOR_ADDITIONAL_DOCUMENTS_TASK = 'additional_documents_task';
}

export default ElementLocators;
